import c from 'classnames';
import * as React from 'react';

export type SeparatorProps = {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Separator: React.FC<SeparatorProps> = ({
  orientation = 'horizontal',
  className,
  ...props
}) => (
  <div
    role="separator"
    aria-orientation={orientation}
    className={c(
      orientation === 'horizontal'
        ? `border-t border-grey-300`
        : 'border-r border-grey-300',
      orientation === 'horizontal' ? 'my-4 h-px w-full' : 'mx-4 h-6 w-px',
      className
    )}
    {...props}
  />
);
